import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserContext } from '@typeDefs/home/responses/home';

@Injectable({
  providedIn: 'root',
})
export class HomeApiService {
  private http = inject(HttpClient);

  private userContext$ = this.http.get<UserContext>('/Account/GetUserContext');
  userContext = toSignal(this.userContext$, { initialValue: null });
}
